import { Divider } from '@mui/material';
import TextField from '@mui/material/TextField';
import { MemreButton, MemreFlexBox, MemreSortableList } from 'components/core';
import { InstructionalContent } from 'services/useItem.service/interactions';
import { useAuthoringContext } from '../AuthoringContext';
import InstructionalBlock from './../components/InstructionalBlock';
import PdfBlock from './../components/InstructionalBlock/PdfBlock';

export default function InstructionalContentElement() {
  const instructionalContent = useAuthoringContext()?.item as InstructionalContent;

  const sortedItems = instructionalContent.blocks;

  const handleOrder = (newOrder, itemId) => {
    const itemPosition = newOrder.indexOf(itemId) + 1;
    instructionalContent.order(itemId, itemPosition);
  };

  return (
    <MemreFlexBox
      direction="column"
      gap={2}
      sx={{
        p: 2,
        pl: 0,
        width: '100%',
        overflowY: 'scroll',
      }}
    >
      <MemreFlexBox direction="row" gap={2}>
        <TextField
          label="Title Text"
          variant="outlined"
          sx={{ flex: 1 }}
          value={instructionalContent.title}
          onChange={(e) => instructionalContent.updateTitle(e.target.value)}
        />
      </MemreFlexBox>
      <Divider sx={{ width: '100%', m: 0.5 }} />

      {instructionalContent.icSubtype === 'instructional_page' ? (
        <>
          <MemreSortableList
            restrictAxis="y"
            onReorder={handleOrder}
            items={sortedItems}
            render={(item, dragHandle) => <InstructionalBlock key={item.id} item={item} dragHandle={dragHandle} />}
          />
          <MemreButton
            variant="text"
            text="Add Block"
            size="small"
            iconName="plus"
            onClick={instructionalContent.add}
          />
        </>
      ) : (
        // Instructional document (PDF) view - simple, undeletable PdfBlock
        <div
          className="pdf-document-container"
          style={{ padding: '20px', border: '1px solid #eee', borderRadius: '4px' }}
        >
          {/* A PDF instructional item should always have exactly one annotation */}
          <PdfBlock item={sortedItems[0]} />
        </div>
      )}
    </MemreFlexBox>
  );
}
